import { FieldsetHTMLAttributes } from 'react';
import { OmitClassName } from '../../../types';
import { joinClassNames } from '../../../utils';
import { RequiredIndicator } from '../RequiredIndicator';
import formStyles from '../styles.module.scss';
import styles from './styles.module.scss';

export type FieldsetProps = OmitClassName<FieldsetHTMLAttributes<HTMLFieldSetElement>> & {
  className?: string;
  /**
   * Only applicable when used with `<FieldWrapper>` (see examples in FieldWrapper/Fieldset)
   */
  showChildErrorStyles?: boolean;

  /** @deprecated - use `Legend` as a child instead */
  legend?: string;

  /**
   * @deprecated - Request a legend from a designer to make the fieldset accessible,
   * don't include a legend at all or don't use a fieldset.
   **/
  hideLegend?: boolean;

  /** @deprecated - use `<Legend>My title <RequiredIndicator />` as a child instead. */
  isRequired?: boolean;
};

export const Fieldset = ({
  children,
  legend,
  className,
  hideLegend = false,
  isRequired = false,
  showChildErrorStyles = false,
  ...attributes
}: FieldsetProps) => (
  <fieldset
    className={joinClassNames(
      formStyles.fieldset,
      showChildErrorStyles && formStyles.showChildErrorStyles,
      className
    )}
    {...attributes}
  >
    {legend ? (
      <legend className={styles.legend} hidden={hideLegend}>
        {legend}
        {isRequired && (
          <>
            {' '}
            <RequiredIndicator />
          </>
        )}
      </legend>
    ) : (
      false
    )}
    {children}
  </fieldset>
);
